const state = {
  STATUS_NOT_COLLECT: 1,
  STATUS_COLLECT_WAIT: 2,
  STATUS_COLLECTING: 3,
  STATUS_COLLECTED: 4,
  STATUS_CONFIRMED: 5,
}
const getters = {}
const actions = {}
const mutations = {}

export const storeCollection = {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/views/store-collection/store.collection.store.js